import { TrialMessagingConfig } from '../trial/trialConstants';
import { getParsedTrialId } from '../trial/trialUtils';
import { Step } from '../views/Step';
export const getTrialMessaging = () => {
  const trialId = getParsedTrialId();
  const landingPageMessaging = trialId && TrialMessagingConfig.get(trialId);

  if (landingPageMessaging) {
    return new Map([[Step.LandingPage, landingPageMessaging]]);
  }

  return null;
};